import { Outlet } from "react-router-dom";
import { NavBar } from "../NavBar";
import FooterScreen from "../FooterScreen/FooterScreen";

const LayoutComponent = () => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <NavBar />

      <main className="pt-16 flex-grow">
        <Outlet />
      </main>

      <FooterScreen />
    </div>
  );
};

export default LayoutComponent;